if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyButton = this.querySelector('.sticky-atc .product-form__submit');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        /* Dawn enables the hidden variant id once JS is running. Leave it
           disabled alongside the submit button when the variant is sold out,
           otherwise a later script that re-enables Add to cart can still post. */
        if (!this.isSoldOutSubmit()) this.variantIdInput.disabled = false;
        this.syncSoldOutDisabled();
        this.observeSoldOutDisabled();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // monumental added for cutsom gtm event
        window.dispatchEvent(new CustomEvent('ga4:atc', { bubbles: true }));
        // end monumental
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.stickyButton) {
        this.stickyButton.setAttribute('aria-disabled', true);
        this.stickyButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    //this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              //this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.stickyButton) {
            this.stickyButton.classList.remove('loading');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.stickyButton) {
            if (!this.error) this.stickyButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      isSoldOutSubmit() {
        if (!this.submitButton) return false;
        if (this.submitButton.hasAttribute('disabled')) return true;
        const text = (this.submitButtonText?.textContent || '').replace(/\s+/g, ' ').trim();
        const strings = window.variantStrings || {};
        return text === strings.soldOut || text === strings.unavailable;
      }

      syncSoldOutDisabled() {
        if (!this.submitButton || !this.isSoldOutSubmit()) return;
        this.submitButton.setAttribute('disabled', 'disabled');
        if (this.variantIdInput) this.variantIdInput.disabled = true;
      }

      /* Liquid renders the button disabled, but app scripts (Stylux, Swym, Shop
         Pay) often strip that attribute without changing the label. Put it back
         whenever the button still reads as sold out. */
      observeSoldOutDisabled() {
        if (!this.submitButton || this._soldOutObserver) return;
        this._soldOutObserver = new MutationObserver(() => {
          if (this.isSoldOutSubmit() && !this.submitButton.disabled) {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
        });
        this._soldOutObserver.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          if (text) this.submitButtonText.textContent = text;
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.variantIdInput) this.variantIdInput.disabled = true;
        } else {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButton.removeAttribute('disabled');
          if (this.variantIdInput) this.variantIdInput.disabled = false;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
